'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { getValidQuote } = require('./shippingHelpers.es');
const { LOCAL } = require('./ShippingConstants.json');

function QuoteSecondary({ quotes, currency }) {
    if (quotes.local.length && quotes.domestic.length) {
        const { output } = getValidQuote({
            quotes: quotes.local,
            regionType: LOCAL,
            currency,
        });

        if (output) {
            return <div data-tn="shipping-secondary">({output})</div>;
        }
    }
    return null;
}

QuoteSecondary.propTypes = {
    quotes: PropTypes.shape({
        local: PropTypes.arrayOf(PropTypes.object).isRequired,
        domestic: PropTypes.arrayOf(PropTypes.object).isRequired,
    }).isRequired,
    currency: PropTypes.string.isRequired,
};

module.exports = QuoteSecondary;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/QuoteSecondary.jsx